function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.3566 6.35624L8.35659 11.3562C8.2618 11.4501 8.13377 11.5028 8.00034 11.5028C7.86692 11.5028 7.73889 11.4501 7.64409 11.3562L2.64409 6.35624C2.57626 6.28395 2.53029 6.19393 2.51148 6.0966C2.49268 5.99927 2.50182 5.8986 2.53784 5.80624C2.57609 5.71524 2.64042 5.6376 2.72273 5.5831C2.80503 5.5286 2.90163 5.49969 3.00034 5.49999H13.0003C13.0991 5.49969 13.1957 5.5286 13.278 5.5831C13.3603 5.6376 13.4246 5.71524 13.4628 5.80624C13.4989 5.8986 13.508 5.99927 13.4892 6.0966C13.4704 6.19393 13.4244 6.28395 13.3566 6.35624Z",
  fill: "#00965e"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/prices-up.d4c40bfc.svg";
export { SvgComponent as ReactComponent };